var urlParams = new URLSearchParams(window.location.search);
var WishListContainer = document.getElementById("WishListProductGridContainer"); 
function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const d = new Date;
        d.setTime(d.getTime() + days * 24 * 60 * 60 * 1e3),
        expires = "; expires=" + d.toUTCString()
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/"
}
function getCookie(name) {
    const nameEQ = name + "="
      , ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        for (; c.charAt(0) === " "; )
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return c.substring(nameEQ.length, c.length)
    }
    return null
}
function updateWishlistHeader(wishlist) {
  const headers = document.querySelectorAll(".header__icon-cloud");
  headers.forEach(header => {
    if (wishlist.length > 0) {
      header.classList.add("active");
    } else {
      header.classList.remove("active");
    }
  });
}
function updateHearts(wishlist) {
    document.querySelectorAll(".wishlist-heart").forEach(heart => {
        const productId = heart.dataset.productId;
        wishlist.includes(productId) ? heart.classList.add("active") : heart.classList.remove("active")
    })
}
function loadWishList(wishlist) {
   if (wishlist.length === 0) {
   } else {
        WishListContainer.innerHTML = "";
        const query = wishlist.map(id => `id:${id}`).join("+OR+");
        fetch(`/search?q=${query}&type=product`)
        .then(res => res.text())
        .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");
                const products = doc.querySelectorAll(".search__results .product-item");
                products.forEach(product => {
                WishListContainer.appendChild(product.cloneNode(true));
                updateHearts(wishlist);
            });
        });
    }
}
document.addEventListener("DOMContentLoaded", function() {
    let wishlistCookie = getCookie("wishlist") || "" , wishlist = wishlistCookie ? wishlistCookie.split(",") : [];
    if(WishListContainer) {
        loadWishList(wishlist);
    }
    updateHearts(wishlist);
    updateWishlistHeader(wishlist);
    document.addEventListener("click", function(e) {
        const heart = e.target.closest(".wishlist-heart");
        if (!heart) return;
        const productId = heart.dataset.productId , index = wishlist.indexOf(productId);
        index > -1 ? (wishlist.splice(index, 1),
        heart.classList.remove("active")) : (wishlist.push(productId),
        heart.classList.add("active")),
        setCookie("wishlist", wishlist.join(","), 7),
        updateWishlistHeader(wishlist);
    });
});